var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6211 1.83203H1.93359C0.863629 1.83203 0 2.69566 0 3.76563V11.5C0 12.5699 0.863629 13.4336 1.93359 13.4336H2.57812V15.3672C2.57812 15.8328 3.06028 16.1701 3.53203 15.9344C3.54492 15.9215 3.57075 15.9215 3.58364 15.9086C7.12925 13.5309 6.33463 14.061 7.12856 13.5367C7.23164 13.4722 7.34766 13.4336 7.47656 13.4336H13.6211C14.6911 13.4336 15.5547 12.5699 15.5547 11.5V3.76563C15.5547 2.69566 14.6911 1.83203 13.6211 1.83203ZM8.46484 9.56641H3.22266C2.37304 9.56641 2.36955 8.27734 3.22266 8.27734H8.46484C9.31446 8.27734 9.31795 9.56641 8.46484 9.56641ZM12.332 6.98828H3.22266C2.37304 6.98828 2.36955 5.69922 3.22266 5.69922H12.332C13.1817 5.69922 13.1851 6.98828 12.332 6.98828Z",
    fill: "#818194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 6.98828H16.8438V11.5C16.8438 13.2789 15.4 14.7227 13.6211 14.7227H7.66992L6.44531 15.5348V16.6562C6.44531 17.7261 7.30894 18.5898 8.37891 18.5898H14.7168L18.4164 21.0648C18.9213 21.3452 19.4219 21.0042 19.4219 20.5234V18.5898H20.0664C21.1364 18.5898 22 17.7261 22 16.6562V8.92188C22 7.85195 21.1364 6.98828 20.0664 6.98828Z",
    fill: "#818194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/Chaticon.2a953aa82fab6df21f86aa99d9cbf6d7.svg";
export { ForwardRef as ReactComponent };